import { useFormikContext } from 'formik';
import {
  OptionalSection,
  ValidatedInput,
  WideFormGroup,
} from '../template-components';
import { useRenderWithBulkErrors } from '../../../hooks/useRenderWithBulkErrors';
import { multiplePlaceholder } from '../../../utils/bulkEdits';

const TimingSection = () => {
  const { values } = useFormikContext();
  // if a user attaches a loss event or revenue stream
  // we want the scale of the operation to depend solely on the values there
  // so, make the operation run once a year, and disable changing this
  const disableYearSelectionMessage =
    values.lossEvents?.length > 0
      ? 'Timing set by Loss Events'
      : values.revenueStreams?.length > 0
      ? 'Timing set by Sales Channels'
      : '';

  const { renderWithBulkErrors } = useRenderWithBulkErrors('operations');

  return (
    <>
      <h3>Timing</h3>
      {disableYearSelectionMessage ? (
        <div>{disableYearSelectionMessage}</div>
      ) : (
        <>
          <div className="d-flex w-100">
            <ValidatedInput
              formGroupClassName="w-25"
              label="Cadence (years)"
              maxWidth="100%"
              min={0}
              name="cadence"
              placeholder={multiplePlaceholder(values.cadence, 'Cadence')}
              type="number"
            >
              {renderWithBulkErrors('cadence')}
            </ValidatedInput>
            <ValidatedInput
              formGroupClassName="w-25"
              label="Starting year"
              maxWidth="100%"
              max={30}
              min={1}
              name="startingYear"
              placeholder={multiplePlaceholder(values.startingYear, 'Start')}
              type="number"
            >
              {renderWithBulkErrors('startingYear')}
            </ValidatedInput>
            <ValidatedInput
              formGroupClassName="w-25"
              label="Ending year"
              maxWidth="100%"
              max={30}
              min={1}
              name="endingYear"
              placeholder={multiplePlaceholder(values.endingYear, 'End')}
              type="number"
            >
              {renderWithBulkErrors('endingYear')}
            </ValidatedInput>
            <ValidatedInput
              formGroupClassName="w-25"
              label="Times per year"
              maxWidth="100%"
              min={0}
              name="timesPerYear"
              placeholder={multiplePlaceholder(values.timesPerYear, 'Times')}
              type="number"
            >
              {renderWithBulkErrors('timesPerYear')}
            </ValidatedInput>
          </div>
          <WideFormGroup>
            <OptionalSection
              forceShown={!!values.years?.length}
              buttonContent="Add custom years"
            >
              <ValidatedInput
                label="Custom years"
                type="text"
                name="years"
                placeholder="Years (comma separated)"
                value={multiplePlaceholder(values.years, values.years)}
                formGroupClassName="mb-0"
                size="med"
              >
                {renderWithBulkErrors('years')}
              </ValidatedInput>
            </OptionalSection>
          </WideFormGroup>
        </>
      )}
    </>
  );
};

export default TimingSection;
